<template>
  <div>
    <div class="search-index">
      <div class="head">
        <div class="bigsearch">搜索</div>
        <div class="close" @click="goBack">
          <img
            src="@/assets/img/close.png"
            alt=""
            style="width: 33px; height: 33px"
          />
        </div>
      </div>
      <div class="input-wrap">
        <a-input-search
          v-model:value="keyword"
          placeholder="请输入要搜索的内容"
          @search="onSearch"
          size="large"
        ><template #enterButton><i class="iconfont icon-sousuo"></i></template>
        </a-input-search>
      </div>
      <div class="hot-rec">
        <div class="rec-title" style="color:#e75934">
         热搜词
        </div>
        <div class="list">
          <a-tag
            v-for="item in hotKeywords"
            :key="item"
            color="red"
            @click="goSearch(item)"
            >{{ item }}</a-tag
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, toRefs } from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
  setup() {
    const router = useRouter();
    const state = reactive({
      keyword: "",
      hotKeywords: [
        "图书馆学",
        "智慧图书馆",
        "高校图书馆",
        "公共图书馆",
        "阅读推广",
        "信息服务",
        "图书馆服务",
        "知识管理",
        "信息行为",
        "机构知识库",
      ],
    });
    const goBack=()=>{
        router.back()
    }
    const onSearch = () => {
      if (state.keyword === "") {
        return false;
      }
      goSearch(state.keyword);
    };

    const goSearch = (keyword) => {
      router.push({ path: "/totalCount", query: { keyword } });
    };
    return {
      ...toRefs(state),
      onSearch,
      goSearch,
      goBack
    };
  },
});
</script>
<style lang="scss">
#app {
  .input-wrap {
    .ant-input:hover,.ant-input:focus {
      border-color:#d9d9d9;
    }
    .ant-btn-primary {
      background:#fff;
      color:#666;
      border-color:#d9d9d9;
      border-left:none;
      padding:0 10px;
      .iconfont {
        font-size:20px;
      }
    }
  }
}


</style>
<style lang="scss" scoped>
@import "../../scss/_variables.scss";
.ant-input {
    background-color: #fff !important; 
}
.main-block{
  background-color:#fff
}
.search-index {
  width: 900px;
  margin: 0 auto;
  padding-top: 120px;
  .head {
    display: flex;
    justify-content: space-between;
    .bigsearch {
      font-size: 36px;
      width: 73px;
      height: 50px;
      font-weight: 600;
      color: #333333;
      line-height: 50px;
      margin-bottom: 23px;
    }
    .close {
      line-height: 50px;
      cursor: pointer;
    }
  }
  .input-wrap {
    background: #fff;
    border-radius: 2px;
    .ant-input-affix-wrapper {
      border: none;
    }
    .ant-input-affix-wrapper-focused {
      box-shadow: none;
    }
    
  }
}
/deep/.ant-input-search-icon {
  color: #e9623f !important;
}

.hot-rec {
  width: 900px;
  margin: 20px auto;
  .rec-title {
    font-size: 16px;
    margin-bottom: 10px;
    .iconfont {
      color: $primary-color;
      font-size: 28px;
    }
  }
  .list {
    .ant-tag {
      padding: 5px 15px;
      margin-bottom: 10px;
      margin-right: 15px;
      cursor: pointer;
      font-weight: 400;
      color: #333333;
      line-height: 20px;
    }
    //标签red 调整
    .ant-tag-red {
      color: #333;
      background: #f2f2f2;
      border-color: #f2f2f2;
          font-size: 15px;
    }
    .ant-tag-red:hover{
        background: #FBF3F0;
        border: 1px solid #fff;
    }
  }
}
</style>